import React, { useRef, useState } from 'react'
import Button from '../button/button'
import posthog from 'posthog-js'
import styled from 'styled-components'
import './upload.scss'

const StyledButton = styled(Button)`
  font-size: 1em;
`

const FORM_ACTION = process.env.NODE_ENV === 'production' ? '/upload' : 'http://localhost:3000/upload'

const Upload = () => {
  const formRef = useRef()
  const [loading, setLoading] = useState(false)

  const onSubmit = (event) => {
    if (!formRef.current[0].files.length) {
      event.preventDefault()
      alert('Please select a file to upload.')
    }
    posthog.capture('upload_started')
    setLoading(true)
  }

  let uploadText = 'Upload (.PUZ)'
  if (loading) {
    uploadText = 'Uploading...'
  }

  return (
    <div className='UploadBox'>
      <h1>Upload</h1>
      <form action={FORM_ACTION} method='POST' encType='multipart/form-data' ref={formRef} onSubmit={onSubmit}>
        <input type='file' name='puzzle' accept='.puz' />
        <input type='hidden' name='userToken' value={localStorage.getItem('userToken')} />
        <br /><br />
        <StyledButton
          className='button'
          type='submit'
          disabled={loading}
          text={uploadText} />
      </form>
    </div>
  )
}

export default Upload
